import React from "react";
import { TouchableOpacity } from "react-native";
import { View, StyleSheet } from "react-native";
import { Text, typography, theme, Icon } from "ui-components";
import { getUnitNumber } from "../../../screens/new/utils/helper";

interface DeleteMyUnitProps {
  propertyName?: string;
  propertyUnit: string;
  testID?: string;
  reservationLength: number;
  accessibilityLabel?: string;
  onPressDelete?: any;
  id?: any;
}
export const DeleteMyUnit = (props: DeleteMyUnitProps) => {
  const {
    propertyName,
    propertyUnit,
    testID,
    accessibilityLabel,
    onPressDelete,
    reservationLength,
    id,
  } = props;
  return (
    <View
      style={styles.container}
      testID={`${testID}-container`}
      accessibilityLabel={`${accessibilityLabel} container`}>
      <View style={{ flex: 1 }}>
        <Text
          style={styles.propertyName}
          testID={`${testID}-property-name`}
          accessibilityLabel={`${accessibilityLabel} property name`}>
          {propertyName}
        </Text>
        <Text
          style={styles.propertyUnit}
          testID={`${testID}-property-unit`}
          accessibilityLabel={`${accessibilityLabel} property unit`}>
          Unit: {getUnitNumber(propertyUnit)}
        </Text>
      </View>
      {reservationLength > 1 ? (
        <TouchableOpacity
          activeOpacity={0.6}
          style={styles.deleteIconContainer}
          onPress={() => onPressDelete(props)}
          testID={`${testID}-delete-button`}
          accessibilityLabel={`${accessibilityLabel} delete button`}>
          <Icon name="delete" color={theme.colors.alert} size={theme.iconSize.medium} />
        </TouchableOpacity>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 10,
    paddingLeft: 24,
    paddingRight: 22,
    backgroundColor: theme.colors.white,
  },
  propertyName: {
    ...typography.title2,
    flex: 1,
    color: theme.colors.secondary,
    fontFamily: "Lato_700Bold",
  },
  propertyUnit: {
    ...typography.body,
    flex: 1,
    color: theme.colors.text3,
  },
  deleteIconContainer: {
    borderWidth: 1,
    padding: 10,
    borderRadius: 25,
    borderColor: theme.colors.stroke,
    outlineStyle: "none",
  },
});
